// src/ForgotPassword.js

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from './supabaseClient'; // your Supabase client
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  Grid,
} from '@mui/material';

const APP_URL = process.env.REACT_APP_APP_URL || window.location.origin;

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    // Basic client-side validation
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    try {
      // 1) Request Supabase to send the magic link
      console.log('Sending password reset email to:', email);
      const { data, error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${APP_URL}/reset-password`,
        // IMPORTANT: Make sure "https://demo.comturk.com/reset-password" is
        // listed in your Supabase Auth "Additional Redirect URLs" setting.
      });

      console.log('Password reset email result:', { success: !resetError, data });
      
      if (resetError) {
        console.error('Supabase resetPasswordForEmail error:', resetError);
        console.error('Error details:', JSON.stringify(resetError));
        throw resetError;
      }

      setSuccess('Password reset instructions have been sent to your email.');
      // Optionally navigate to some page:
      setTimeout(() => {
        navigate('/login');
      }, 3000);

    } catch (err) {
      console.error('Error sending reset password email:', err);
      console.error('Error details:', JSON.stringify(err));
      
      // Provide more specific error message based on the error
      if (err.message && err.message.includes('Rate limit')) {
        setError('Too many reset attempts. Please try again later.');
      } else if (err.message && err.message.includes('User not found')) {
        // For security reasons, we don't want to reveal if an email exists or not
        setSuccess('If this email is registered, you will receive password reset instructions.');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setError('Unable to send reset email. Please check your email address and try again.');
      }
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5">
          Reset Password
        </Typography>

        {error && <Alert severity="error" sx={{ width: '100%', mt: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ width: '100%', mt: 2 }}>{success}</Alert>}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="Email Address"
            name="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Send Reset Instructions
          </Button>
          <Grid container>
            <Grid item>
              <Link to="/login">
                Back to Login
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
}

export default ForgotPassword;
